module.exports = __webpack_public_path__ + "3694b065dba55ffa663a158c7d1886dc.png";